import React from 'react';
import { Card, Badge } from 'react-bootstrap';
import './ModifierPreviewSection.scss';

interface ExistingModifier {
  modifier_id: number;
  modifier_name: string;
  modifier_description?: string;
  local_id: number;
  items_affected: Array<{
    item_id: number;
    item_name: string;
  }>;
  options_included: Array<{
    option_id: number;
    option_name: string;
    option_description?: string;
    price_modifier: number;
  }>;
  total_items_affected: number;
  total_options: number;
  has_price_modifiers: boolean;
  has_descriptions: boolean;
  options_with_descriptions: number;
}

interface ModifierPreviewSectionProps {
  selectedModifier: ExistingModifier;
}

const ModifierPreviewSection: React.FC<ModifierPreviewSectionProps> = ({
  selectedModifier
}) => {
  const formatPrice = (price: number) => {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(price);
  };

  return (
    <div className="modifier-preview-section-clean">
      <h6 className="preview-title-clean">Vista Previa del Modificador</h6>
      
      <Card className="preview-card-clean">
        <Card.Header className="preview-header-clean">
          <div className="modifier-info-header-clean">
            <h6 className="modifier-name-preview-clean">{selectedModifier.modifier_name}</h6>
          </div>
          <Badge bg="primary" className="options-count-badge-clean">
            {selectedModifier.total_options} opciones
          </Badge>
        </Card.Header>
        
        <Card.Body className="preview-body-clean">
          <div className="options-list-container-clean">
            <div className="options-list-clean">
              {selectedModifier.options_included.map(option => (
                <div key={option.option_id} className="option-item-clean">
                  <div className="option-content-clean">
                    <span className="option-name-clean">{option.option_name}</span>
                  </div>
                  <div className="option-price-clean">
                    {option.price_modifier !== 0 ? (
                      <Badge 
                        className={`price-modifier-badge-clean ${option.price_modifier > 0 ? 'positive' : 'negative'}`}
                      >
                        {option.price_modifier > 0 ? '+' : ''}{formatPrice(option.price_modifier)}
                      </Badge>
                    ) : (
                      <span className="no-modifier-clean">Sin costo</span>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ModifierPreviewSection;
